export default {
  LeftMenu: {
    Dashboard: "Tổng quan",
    Dashboard_Demo: "Tài khoản chờ duyệt",
    Dashboard_Wating: "Kích hoạt tài khoản",
    Dashboard_Official: "Dashboard",
    Asset: "Tài sản",
    AllocationReduce: "Cấp phát-Thu hồi",
    Maintenance: "Sửa chữa-Bảo dưỡng",
    Transfer: "Điều chuyển",
    InformLostBroken: "Đánh dấu hỏng báo mất",
    LostCancelAssetList: "Mất-Hủy-Thanh lý",
    Tally: "Kiểm đếm",
    Audit: "Kiểm kê",
    Setting: "Thiết lập",
    Maintain: "Lịch bảo dưỡng",
    Paymentlink: "Payment Links",
    PaymentlinkList: "Danh Sách Payment Links",
    MyPaymentLink: "Payment Link QRCode",
    Report: "Báo cáo",
    System: "Hệ thống",
    Options: "Hệ thống",
    SubAccount: "Tài khoản phụ",
    AccountManager: "Quản lý tài khoản",
    Dictionary: "Danh mục",
    Bank_Dictionary: "Tài khoản ngân hàng",
    Logo_Unit: "Logo đơn vị",
    ServiceConnect: "Kết nối dịch vụ",
    Info_Control: "Thông tin đối soát",
    User_management: "Quản lý người dùng",
    Revenue_management: "Dịch vụ thu hộ",
    User: "Người dùng",
    Role: "Vai trò",
    Customer: "Khách hàng",
    Complaint_refund: "Khiếu nại & hoàn tiền",
    Complaint: "Khiếu nại",
    Refund: "Hoàn tiền",
    Transaction_management: "Quản lý giao dịch",
    Control_management: "Quản lý đối soát",
    Control_management_list: "Báo cáo thanh toán",
    Control_report: "Tổng hợp đối soát thanh toán",
    Control_management_bymonth: "Báo cáo đối soát tháng",
    Paymentrequest: "Quản lý khoản phải thu",
    Paymentrequest_pay: "Quản lý khoản phải trả",
    Paymentrequest_contact: "Danh bạ",
    SystemChild: {
      Dictionary: "Danh mục",
      AssetType: "Loại tài sản",
      AssetCategory: "Nhóm tài sản",
      OrganizationUnit: "Cơ cấu tổ chức",
      JobPosition: "Vị trí công việc",
      JobTitle: "Vai trò công việc",
      AssetLocation: "Vị trí tài sản",
      ProviderList: "Nhà cung cấp",
      JobPositionAsset: "Định mức cấp phát",
      Template: "Mẫu văn bản",
      EmployeeList: "Nhân viên",
      System: "Thiết lập hệ thống",
      ManageAccount: "Quản lý người dùng",
      Role: "Vai trò",
      AuditingLog: "Nhật ký truy cập",
      Connect: "Kết nối",
      Options: "Tùy chọn",
    },
    ProfileInfo: "Hồ sơ đăng kí",
  },
  Nav: {
    SearchPlaceHolder: "Tìm kiếm tài sản theo tên, mã tài sản...",
  },
  Message: {
    RequireCompleteProfile: "Vui lòng hoàn tất thủ tục đăng ký hồ sơ để sử dụng tính năng này",
    EmailConfirm: "Vui lòng kích hoạt email và định danh tài khoản để bắt đầu sử dụng dịch vụ",
    Confirm: "Vui lòng định danh tài khoản để bắt đầu sử dụng dịch vụ",
    Identify: "Tài khoản của bạn đang được phê duyệt. Vui lòng quay lại sau",
    ErrorLogin: "Có lỗi xảy ra, vui lòng đăng nhập lại",
    BackDashboard: "Dữ liệu đã thay đổi, bạn có muốn lưu không?",
  },
};
